import { render, staticRenderFns } from "./Popfield.vue?vue&type=template&id=21d701e0&scoped=true&"
import script from "./Popfield.vue?vue&type=script&lang=js&"
export * from "./Popfield.vue?vue&type=script&lang=js&"
import style0 from "./Popfield.vue?vue&type=style&index=0&id=21d701e0&scoped=true&lang=css&"
import style1 from "./Popfield.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d701e0",
  null
  
)

export default component.exports